const textFilterTypes = new Set(["title", "text"])
const rangeFilterTypes = new Set(["number", "currency", "percentage", "count"])
const dateFilterTypes = new Set(["date"])
const selectFilterTypes = new Set(["select"])
const allowedFilterTypes = new Set([
  ...Array.from(textFilterTypes),
  ...Array.from(rangeFilterTypes),
  ...Array.from(dateFilterTypes),
  ...Array.from(selectFilterTypes),
])

export const isFilteringAllowed = (type?: string) => {
  if (!type) {
    return false
  }

  return allowedFilterTypes.has(type)
}

export const isTextFilter = (type?: string) => {
  if (!type) {
    return false
  }

  return textFilterTypes.has(type)
}

export const isRangeFilter = (type?: string) => {
  if (!type) {
    return false
  }

  return rangeFilterTypes.has(type)
}

export const isDateFilter = (type?: string) => {
  if (!type) {
    return false
  }

  return dateFilterTypes.has(type)
}

export const isSelectFilter = (type?: string) => {
  if (!type) {
    return false
  }

  return selectFilterTypes.has(type)
}
